"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports._filterSelectedItems = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _downshift = _interopRequireDefault(require("downshift"));
var _isEqual = _interopRequireDefault(require("lodash/isEqual"));
var _itemList = _interopRequireDefault(require("./item-list"));
var _actionIcons = _interopRequireDefault(require("./action-icons"));
var _selectInput = _interopRequireDefault(require("./select-input"));
var _multiDownshift = _interopRequireDefault(require("./multi-downshift"));
var _stateReducer = _interopRequireWildcard(require("./state-reducer"));
var _icons = require("./icons");
var _isValidItemPredicate = _interopRequireDefault(require("./isValidItemPredicate"));
var _styles = require("./styles");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-console */
/*eslint-disable react/prop-types */

const _canCreateItemDefault = function () {
  let item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let selectedItems = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  return !!item && !(0, _includes.default)(items).call(items, item) && !(0, _includes.default)(selectedItems).call(selectedItems, item);
};

// Dynamically render a Downshift component depending on whether
// or not the multiselect behavior is chosen
const DownshiftHOC = _ref => {
  let {
    multiSelect,
    children,
    ...props
  } = _ref;
  return multiSelect ? /*#__PURE__*/_react.default.createElement(_multiDownshift.default, props, children) : /*#__PURE__*/_react.default.createElement(_downshift.default, props, children);
};
const propTypes = {
  id: _propTypes.default.string,
  /**
   * Use a text input to filter the options based on the entered text.
   */
  useTypeahead: _propTypes.default.bool,
  /**
   * The list of items that can be selected from: either a list of strings or a list of objects.
   * When useCategories is true, this is an array of objects of the form:
   * {category: (String), items: (Array)}. Optional keys: loading, loadingMessage, maxItems
   */
  items: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.string, _propTypes.default.number])),
  /**
   * If true, displays items in sub-lists with categories above them.
   */
  useCategories: _propTypes.default.bool,
  /**
   * Function defining how the item text should be rendered.
   * Only necessary when the list of items passed in are objects.
   * Example: if items are of the format {id: 1, text: 'apple'},
   * you would want itemToString to be: (item) => item ? item.text : ''
   */
  itemToString: _propTypes.default.func,
  /**
   * Function defining how each item should be rendered in the item list.
   * The signature of the function passed to itemToElement must be either:
   *   (item) => <Element />
   *     or
   *   (item, inputValue) => <Element />
   * The optional inputValue parameter may be useful when the component is uncontrolled;
   * it can be passed to the HighlightedText component for substring-match highlighting.
   * Note that while itemToElement is essentially a more powerful itemToString, a sensible itemToString
   * is still typically required in addition to itemToElement because itemToString is needed to:
   * populate the input upon selecting an item when the component is uncontrolled, to determine
   * whether the user can create an item when the component is in creatable mode, etc.
   */
  itemToElement: _propTypes.default.func,
  /**
   * Function for computing a unique key for each item, to make React happy. If unspecified,
   * itemToString will be used instead, which is preferable, but sometimes insufficient. For
   * example, the case where you have multiple items for which you want identical filtering
   * behavior for, but don’t necessarily render the same way (w/ itemToElement).
   */
  itemToKey: _propTypes.default.func,
  /**
   * An optional label that will appear above the input.
   */
  label: _propTypes.default.string,
  /**
   * Used to display placeholder text inside the input.
   */
  placeholder: _propTypes.default.string,
  /**
   * An icon displayed on the right side of the input.
   * Only the specified icons are currently supported.
   * You can change the color of the icon through its props.
   */
  icon: _propTypes.default.oneOf(['ArrowDown', 'Search']),
  /**
   * If true, displays the select in a disabled state.
   */
  disabled: _propTypes.default.bool,
  /**
   * A number that sets the max height of the dropdown in pixels
   * (e.g. 100)
   * If not all items fit within the set height,
   * the user will need to scroll to see the other options.
   */
  maxHeight: _propTypes.default.number,
  /**
   * The largest number of items to be rendered in a list. After
   * this number has been reached, further items will not be
   * displayed. There is no indicator that there are further items.
   * The creatable item is not included in this count.
   */
  maxItems: _propTypes.default.number,
  /**
   * Takes (event, inputString). Fired when the user clicks on
   * the component's icon.
   */
  onIconClick: _propTypes.default.func,
  /**
   * Controls whether the menu should open when the icon is clicked.
   *
   * When set to `false` (default), opens the menu when the icon is clicked.
   * When set to `true`, does not open the menu when the icon is clicked.
   */
  disableOpenOnIconClick: _propTypes.default.bool,
  /**
   * If provided, a "clear" icon will be displayed once an item
   * is selected. When the clear icon is clicked, the function passed to
   * onClear will be called. It's argument will be Downshift's clearSelection
   * function which allows the consumer to clear the current inputValue
   * and selectedValue.
   * Example:
   *  <Select
   *    onClear={(clearSelection) => {
   *      // This can be anything you want
   *      doSomething();
   *
   *      // Call this to clear the input/selection
   *      clearSelection();
   *    }}
   *  />
   */
  onClear: _propTypes.default.func,
  /**
   * Takes (itemString, inputValue) and returns a boolean that specifies
   * if the item should appear in the results based on the inputValue.
   * This prop should only be used if useTypeahead is set to true.
   * Default behavior: true when the input string matches any substring of an item
   * (case insensitive).
   */
  filterItems: _propTypes.default.func,
  /**
   * Placement for where the option list should appear.
   */
  placement: _propTypes.default.oneOf(['below', 'above']),
  /**
   * An array of error messages that will be rendered
   * below the select element as paragraph tags.
   */
  errors: _propTypes.default.arrayOf(_propTypes.default.string),
  /**
   * If true, will allow the user to select an item not already in the list that
   * has been generated based on their input. Item appears at the bottom of the list.
   * Only works in typeahead mode. See the Gotchas section below.
   */
  creatable: _propTypes.default.bool,
  /**
   * Takes (inputString) and returns a string that is the text to display in the
   * dropdown for the create new item message. Can only be used with creatable=true.
   */
  createMessage: _propTypes.default.func,
  /**
   * String message to display when no options are found for Select. Required for properly displaying
   * No Options message when items list is empty. Ignored when select is creatable.
   */
  noOptionsMessage: _propTypes.default.string,
  /**
   * Takes (inputString, listOfItemsAsStrings, listOfSelectedItemsAsStrings) and
   * returns true if the user is allowed to create a new item based on the given
   * inputString, false otherwise. Items will be passed through itemToString
   * before being passed to second and third args. Can only be used with creatable=true.
   * Default behavior checks for an exact match in the lists (case sensitive).
   */
  canCreateItem: _propTypes.default.func,
  /**
   * If using a typeahead, the max number of characters a user can type. Useful for creatable.
   */
  maxLength: _propTypes.default.number,
  /**
   * Whether to virtualize the list.
   * Useful for lists with many elements that would otherwise slow down the page
   */
  virtualized: _propTypes.default.bool,
  /**
   * Enable the selection of multiple items. Can be combined with useTypeahead.
   */
  multiSelect: _propTypes.default.bool,
  /**
   * The currently selected item.
   * Set this if you want to use Select as controlled component.
   */
  selectedItem: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.number]),
  /**
   * An array of the currently selected items.
   * Only use when multiSelect is true.
   * Set this if you want to use Select as controlled component.
   */
  selectedItems: _propTypes.default.array,
  /**
   * Called when the user selects or unselects an item and the selected item(s) have changed.
   * Called with the newly selected item(s) and the new state of downshift.
   */
  onChange: _propTypes.default.func,
  /**
   * When set to true, if the user types something and it matches a single option exactly in
   * the dropdown menu, it will be auto-selected. This is the same functional way autofill
   * occurs (it launches an onChange event). NOTE: This ONLY applies to the single typeahead
   * select, as dropdown mode has no support for having an input to autofill within the
   * dropdown select.
   */
  enableAutoSelect: _propTypes.default.bool,
  /**
   * When set to true, don't open the dropdown menu when the typeahead input is empty.
   * NOTE: This ONLY applies to the typeahead selects.
   * This will be overriden if you use stateReducer.
   */
  hideDropdownWhenInputIsEmpty: props => {
    if (typeof props.hideDropdownWhenInputIsEmpty !== 'boolean') return new Error('Expected `hideDropdownWhenInputIsEmpty` to be a boolean.');
    if (props.hideDropdownWhenInputIsEmpty && !props.useTypeahead) return new Error('`hideDropdownWhenInputIsEmpty` cannot be set if `useTypeahead` is not also set.');
  },
  /**
   * When set to true, this disables the menu closing upon selection of an item.
   * Not useful for multiselect without also using disableAutoModifyText.
   * This will be overridden if you use stateReducer.
   */
  disableCloseOnSelect: _propTypes.default.bool,
  /**
   * When set to true, this leaves the text the user typed in the input box, even upon select
   * or click out. This does not stop chips from appearing in multiselect.
   * This will be overriden if you use stateReducer.
   */
  disableAutoModifyText: _propTypes.default.bool,
  /*
   * When set to true, this will clear out the text from the input box when the user selects
   * an item. It will override the select behavior for disableAutoModifyText. Does not work
   * with enableAutoSelect.
   * This will be overriden if you use stateReducer.
   */
  clearTextOnSelect: _propTypes.default.bool,
  /**
   * An object to be passed as props to the input
   */
  inputProps: _propTypes.default.object,
  /**
   * An object to be passed as props to the listbox
   */
  listboxProps: _propTypes.default.object,
  /**
   * Controlled prop that tells the select if items are still being fetched.
   * When set to true, will not show any items and instead will show the
   * loadingMessage in the dropdown menu. It will also not show the
   * noOptionsMessage or the createMessage when creatable is set to true.
   */
  loading: _propTypes.default.bool,
  /**
   * The message that will be shown in the dropdown menu when the loading
   * prop is set to true.
   */
  loadingMessage: _propTypes.default.string,
  /**
   * Allows specifying a width for the item list.
   * "input" restricts it to the width of the input
   * "auto" allows items to take up the width needed based on value
   * Other acceptable width (e.g. "100%" or "100px") values can also be applied.
   */
  itemListWidth: _propTypes.default.oneOfType([_propTypes.default.oneOf(['input', 'auto']), _propTypes.default.string, _propTypes.default.number]),
  /**
   * Allows specifying a max-width for the item list.
   * Accepts standard max-width values (e.g. "100%" or "100px").
   */
  itemListMaxWidth: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
const defaultProps = {
  id: null,
  useTypeahead: false,
  items: [],
  itemToString: _downshift.default.defaultProps.itemToString,
  icon: 'ArrowDown',
  disabled: false,
  filterItems: _isValidItemPredicate.default,
  placement: 'below',
  creatable: false,
  createMessage: item => `Create "${item}"`,
  canCreateItem: _canCreateItemDefault,
  virtualized: false,
  errors: [],
  multiSelect: false,
  onChange: () => null,
  noOptionsMessage: 'No Options',
  enableAutoSelect: false,
  hideDropdownWhenInputIsEmpty: false,
  disableCloseOnSelect: false,
  disableAutoModifyText: false,
  clearTextOnSelect: false,
  inputProps: {},
  listboxProps: {},
  loading: false,
  loadingMessage: 'Loading...',
  itemListWidth: 'input',
  disableOpenOnIconClick: false
};
const Select = _ref2 => {
  let {
    className,
    useTypeahead,
    items,
    useCategories,
    label,
    placeholder,
    placement,
    icon,
    disabled,
    onIconClick,
    onClear,
    maxHeight,
    itemToString,
    itemToElement,
    itemToKey,
    filterItems,
    maxItems,
    creatable,
    createMessage,
    canCreateItem,
    maxLength,
    virtualized,
    errors,
    multiSelect,
    enableAutoSelect,
    hideDropdownWhenInputIsEmpty,
    disableCloseOnSelect,
    disableAutoModifyText,
    clearTextOnSelect,
    onChange,
    noOptionsMessage,
    inputProps,
    listboxProps,
    loading,
    loadingMessage,
    itemListWidth,
    itemListMaxWidth,
    header,
    footer,
    disableOpenOnIconClick,
    ...props // Additional props passed to Downshift component
  } = _ref2;
  if (virtualized && creatable) {
    console.warn("@kyruus/select: Using prop 'creatable' with 'virtualized' is unsupported.");
  }
  const modifyInputValueOnSelectFn = (0, _stateReducer.constructModifyInputValueOnSelectFn)({
    multiSelect,
    disableAutoModifyText,
    clearTextOnSelect
  });
  return /*#__PURE__*/_react.default.createElement(DownshiftHOC, (0, _extends2.default)({
    multiSelect: multiSelect,
    itemToString: itemToString,
    onChange: onChange,
    stateReducer: (0, _stateReducer.default)({
      multiSelect,
      hideDropdownWhenInputIsEmpty,
      disableCloseOnSelect,
      modifyInputValueOnSelectFn
    })
  }, props), _ref3 => {
    var _context, _context2;
    let {
      getInputProps,
      getToggleButtonProps,
      getItemProps,
      getLabelProps,
      getMenuProps,
      getRemoveButtonProps,
      toggleMenu,
      removeItem,
      isOpen,
      inputValue,
      highlightedIndex,
      selectItem,
      selectedItem,
      selectedItems,
      clearSelection,
      getRootProps
    } = _ref3;
    isOpen = isOpen && !disabled;
    const flattenItems = items => {
      if (!useCategories) return items;
      let flatItems = [];
      (0, _map.default)(items).call(items, categoryItems => {
        flatItems = (0, _concat.default)(flatItems).call(flatItems, categoryItems.items);
      });
      return flatItems;
    };

    // Only unselected items should be shown in the dropdown
    let unselectedItems = items;
    if (multiSelect) {
      unselectedItems = _applyToItems(items, items => _filterSelectedItems(items, selectedItems), useCategories);
    }
    let createItemMessage;
    if (useTypeahead && creatable && canCreateItem(inputValue, (0, _map.default)(_context = flattenItems(items)).call(_context, item => itemToString(item)), multiSelect ? (0, _map.default)(selectedItems).call(selectedItems, item => itemToString(item)) : [])) {
      createItemMessage = createMessage(inputValue);
    }

    // Filters items in typeahead down to the items that match the input value.
    // Defer execution so items only get filtered when useTypeahead is true.
    const filteredItems = () => _applyToItems(unselectedItems, items => (0, _filter.default)(items).call(items, item => filterItems(itemToString(item), inputValue)), useCategories);
    const getItems = () => useTypeahead ? filteredItems() : unselectedItems;
    const showClearIcon = inputValue && onClear && !disabled;
    const actionIconsPadding = (0, _icons.getActionIconsWidth)(icon, showClearIcon);
    const safeToggleMenu = () => {
      if (hideDropdownWhenInputIsEmpty) {
        // By default, toggleMenu() dispatches an `undefined` action that
        // would collide with other undefined actions in the stateReducer.
        toggleMenu({
          isOpen: !!inputValue,
          type: 'toggleMenu'
        });
      } else {
        toggleMenu();
      }
    };

    // If an onIconClick is provided, execute the function.
    // If disableOpenOnIconClick is true, don't open the menu
    // If an onIconClick is not provided and disableOpenOnIconClick is true, do nothing
    const handleIconClick = !onIconClick && disableOpenOnIconClick ? undefined : event => {
      if (onIconClick) onIconClick(event, inputValue);
      if (!disableOpenOnIconClick) safeToggleMenu();
    };

    // To allow for custom item list width, render the itemList outside of the main container
    const renderItemListOutsideOfContainer = itemListWidth !== 'input';
    const itemList = /*#__PURE__*/_react.default.createElement(_styles.StyledPaper, (0, _extends2.default)({}, getMenuProps({
      className: 'option-list',
      'data-placement': placement,
      'data-max-height': `${maxHeight}px`,
      maxHeight: maxHeight,
      elevation: placement === 'above' ? 1 : 4,
      ...listboxProps
    }), {
      itemListWidth: renderItemListOutsideOfContainer ? itemListWidth : '100%',
      itemListMaxWidth: itemListMaxWidth
    }), isOpen && (loading ? /*#__PURE__*/_react.default.createElement(_styles.NoOptionsContainer, {
      id: "loading"
    }, loadingMessage) : _shouldShowItemList({
      items: getItems(),
      flattenItems,
      createItemMessage,
      useCategories
    }) ? /*#__PURE__*/_react.default.createElement(_itemList.default, {
      items: getItems(),
      itemsLength: flattenItems(getItems()).length,
      maxItems: maxItems,
      useCategories: useCategories,
      itemToString: itemToString,
      itemToElement: itemToElement,
      itemToKey: itemToKey,
      highlightedIndex: highlightedIndex,
      inputValue: inputValue,
      useTypeahead: useTypeahead,
      getItemProps: getItemProps,
      maxHeight: maxHeight,
      createItemMessage: createItemMessage,
      virtualized: virtualized,
      header: header,
      footer: footer
    }) : /*#__PURE__*/_react.default.createElement(_styles.NoOptionsContainer, null, noOptionsMessage)));
    const rootProps = {};
    if (!useTypeahead) {
      // unset role=combobox if no typeahead input is present
      // https://github.com/downshift-js/downshift/issues/750
      rootProps.role = undefined;
    }
    return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, getRootProps(rootProps, {
      suppressRefError: true
    }), {
      className: className
    }), label && /*#__PURE__*/_react.default.createElement(_styles.StyledLabel, getLabelProps(), label), /*#__PURE__*/_react.default.createElement(_styles.StyledSelectContainer, null, /*#__PURE__*/_react.default.createElement(_selectInput.default, {
      useTypeahead: useTypeahead,
      multiselect: multiSelect,
      selectedItem: selectedItem,
      selectedItems: selectedItems,
      enableAutoSelect: enableAutoSelect,
      placeholder: placeholder,
      isOpen: isOpen,
      inputValue: inputValue,
      getInputProps: getInputProps,
      getToggleButtonProps: getToggleButtonProps,
      getRemoveButtonProps: getRemoveButtonProps,
      actionIconsPadding: actionIconsPadding,
      safeToggleMenu: safeToggleMenu,
      removeItem: removeItem,
      itemToString: itemToString,
      maxLength: maxLength,
      disabled: disabled,
      containsErrors: errors.length > 0,
      selectItem: selectItem,
      items: flattenItems(unselectedItems),
      filterItems: filterItems,
      onKeyDownProps: {
        highlightedIndex,
        loading: loading || useCategories && (0, _find.default)(_context2 = getItems()).call(_context2, item => item.loading),
        createItemMessage,
        modifyInputValueOnSelectFn
      },
      inputProps: inputProps
    }), /*#__PURE__*/_react.default.createElement(_actionIcons.default, {
      icon: icon,
      disabled: disabled,
      onIconClick: handleIconClick,
      inputValue: inputValue,
      onClear: onClear && (() => onClear(clearSelection))
    }), !renderItemListOutsideOfContainer && itemList, /*#__PURE__*/_react.default.createElement("div", {
      id: props.id ? `${props.id}-errors` : undefined
    }, (0, _map.default)(errors).call(errors, error => /*#__PURE__*/_react.default.createElement(_styles.ErrorMessage, {
      key: error
    }, error)))), renderItemListOutsideOfContainer && itemList);
  });
};

// Always use this function when doing operations on the items prop
// Returns a new instance of items where applyFunction has been applied to
// every every item in items while retaining the original structure.
// applyFunction takes items as its singular argument, performs the operation,
// and returns the result
const _applyToItems = (items, applyFunction, useCategories) => {
  let appliedItems = [];
  if (useCategories) {
    (0, _forEach.default)(items).call(items, (categoryItems, index) => {
      appliedItems[index] = {
        ...categoryItems,
        items: applyFunction(categoryItems.items)
      };
    });
  } else {
    appliedItems = applyFunction(items);
  }
  return appliedItems;
};
const _shouldShowItemList = _ref4 => {
  let {
    items,
    flattenItems,
    createItemMessage,
    useCategories
  } = _ref4;
  // If we have a create item message, that is rendered by the list
  if (createItemMessage) return true;
  // If we are using categories, we need to render the list if any of the categories are loading
  if (useCategories) {
    if ((0, _find.default)(items).call(items, categoryItems => categoryItems.loading)) return true;
  }
  // If there are items, show the list of them
  // (This is the obvious check, but it's the most expensive so do it last)
  if (flattenItems(items).length) return true;
  return false;
};
const _filterSelectedItems = (allItems, selectedItems) => (0, _filter.default)(allItems).call(allItems, item => !(0, _some.default)(selectedItems).call(selectedItems, selectedItem => (0, _isEqual.default)(selectedItem, item)));
exports._filterSelectedItems = _filterSelectedItems;
Select.propTypes = propTypes;
Select.defaultProps = defaultProps;
var _default = exports.default = Select;
Select.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Select",
  "props": {
    "id": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "useTypeahead": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Use a text input to filter the options based on the entered text.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "items": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "The list of items that can be selected from: either a list of strings or a list of objects.\nWhen useCategories is true, this is an array of objects of the form:\n{category: (String), items: (Array)}. Optional keys: loading, loadingMessage, maxItems",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "union",
          "value": [{
            "name": "object"
          }, {
            "name": "string"
          }, {
            "name": "number"
          }]
        }
      },
      "required": false
    },
    "itemToString": {
      "defaultValue": {
        "value": "Downshift.defaultProps.itemToString",
        "computed": true
      },
      "description": "Function defining how the item text should be rendered.\nOnly necessary when the list of items passed in are objects.\nExample: if items are of the format {id: 1, text: 'apple'},\nyou would want itemToString to be: (item) => item ? item.text : ''",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "icon": {
      "defaultValue": {
        "value": "'ArrowDown'",
        "computed": false
      },
      "description": "An icon displayed on the right side of the input.\nOnly the specified icons are currently supported.\nYou can change the color of the icon through its props.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'ArrowDown'",
          "computed": false
        }, {
          "value": "'Search'",
          "computed": false
        }]
      },
      "required": false
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, displays the select in a disabled state.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "filterItems": {
      "defaultValue": {
        "value": "stringContainsSubstring",
        "computed": true
      },
      "description": "Takes (itemString, inputValue) and returns a boolean that specifies\nif the item should appear in the results based on the inputValue.\nThis prop should only be used if useTypeahead is set to true.\nDefault behavior: true when the input string matches any substring of an item\n(case insensitive).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "placement": {
      "defaultValue": {
        "value": "'below'",
        "computed": false
      },
      "description": "Placement for where the option list should appear.",
      "type": {
        "name": "enum",
        "value": [{
          "value": "'below'",
          "computed": false
        }, {
          "value": "'above'",
          "computed": false
        }]
      },
      "required": false
    },
    "creatable": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "If true, will allow the user to select an item not already in the list that\nhas been generated based on their input. Item appears at the bottom of the list.\nOnly works in typeahead mode. See the Gotchas section below.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "createMessage": {
      "defaultValue": {
        "value": "(item) => `Create \"${item}\"`",
        "computed": false
      },
      "description": "Takes (inputString) and returns a string that is the text to display in the\ndropdown for the create new item message. Can only be used with creatable=true.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "canCreateItem": {
      "defaultValue": {
        "value": "(item = '', items = [], selectedItems = []) => {\n  return !!item && !items.includes(item) && !selectedItems.includes(item);\n}",
        "computed": false
      },
      "description": "Takes (inputString, listOfItemsAsStrings, listOfSelectedItemsAsStrings) and\nreturns true if the user is allowed to create a new item based on the given\ninputString, false otherwise. Items will be passed through itemToString\nbefore being passed to second and third args. Can only be used with creatable=true.\nDefault behavior checks for an exact match in the lists (case sensitive).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "virtualized": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Whether to virtualize the list.\nUseful for lists with many elements that would otherwise slow down the page",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "errors": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "description": "An array of error messages that will be rendered\nbelow the select element as paragraph tags.",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "string"
        }
      },
      "required": false
    },
    "multiSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Enable the selection of multiple items. Can be combined with useTypeahead.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "onChange": {
      "defaultValue": {
        "value": "() => null",
        "computed": false
      },
      "description": "Called when the user selects or unselects an item and the selected item(s) have changed.\nCalled with the newly selected item(s) and the new state of downshift.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "noOptionsMessage": {
      "defaultValue": {
        "value": "'No Options'",
        "computed": false
      },
      "description": "String message to display when no options are found for Select. Required for properly displaying\nNo Options message when items list is empty. Ignored when select is creatable.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "enableAutoSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When set to true, if the user types something and it matches a single option exactly in\nthe dropdown menu, it will be auto-selected. This is the same functional way autofill\noccurs (it launches an onChange event). NOTE: This ONLY applies to the single typeahead\nselect, as dropdown mode has no support for having an input to autofill within the\ndropdown select.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "hideDropdownWhenInputIsEmpty": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When set to true, don't open the dropdown menu when the typeahead input is empty.\nNOTE: This ONLY applies to the typeahead selects.\nThis will be overriden if you use stateReducer.",
      "type": {
        "name": "custom",
        "raw": "(props) => {\n  if (typeof props.hideDropdownWhenInputIsEmpty !== 'boolean')\n    return new Error(\n      'Expected `hideDropdownWhenInputIsEmpty` to be a boolean.'\n    );\n  if (props.hideDropdownWhenInputIsEmpty && !props.useTypeahead)\n    return new Error(\n      '`hideDropdownWhenInputIsEmpty` cannot be set if `useTypeahead` is not also set.'\n    );\n}"
      },
      "required": false
    },
    "disableCloseOnSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When set to true, this disables the menu closing upon selection of an item.\nNot useful for multiselect without also using disableAutoModifyText.\nThis will be overridden if you use stateReducer.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "disableAutoModifyText": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "When set to true, this leaves the text the user typed in the input box, even upon select\nor click out. This does not stop chips from appearing in multiselect.\nThis will be overriden if you use stateReducer.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "clearTextOnSelect": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "inputProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "An object to be passed as props to the input",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "listboxProps": {
      "defaultValue": {
        "value": "{}",
        "computed": false
      },
      "description": "An object to be passed as props to the listbox",
      "type": {
        "name": "object"
      },
      "required": false
    },
    "loading": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Controlled prop that tells the select if items are still being fetched.\nWhen set to true, will not show any items and instead will show the\nloadingMessage in the dropdown menu. It will also not show the\nnoOptionsMessage or the createMessage when creatable is set to true.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "loadingMessage": {
      "defaultValue": {
        "value": "'Loading...'",
        "computed": false
      },
      "description": "The message that will be shown in the dropdown menu when the loading\nprop is set to true.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "itemListWidth": {
      "defaultValue": {
        "value": "'input'",
        "computed": false
      },
      "description": "Allows specifying a width for the item list.\n\"input\" restricts it to the width of the input\n\"auto\" allows items to take up the width needed based on value\nOther acceptable width (e.g. \"100%\" or \"100px\") values can also be applied.",
      "type": {
        "name": "union",
        "value": [{
          "name": "enum",
          "value": [{
            "value": "'input'",
            "computed": false
          }, {
            "value": "'auto'",
            "computed": false
          }]
        }, {
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "disableOpenOnIconClick": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "description": "Controls whether the menu should open when the icon is clicked.\n\nWhen set to `false` (default), opens the menu when the icon is clicked.\nWhen set to `true`, does not open the menu when the icon is clicked.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "useCategories": {
      "description": "If true, displays items in sub-lists with categories above them.",
      "type": {
        "name": "bool"
      },
      "required": false
    },
    "itemToElement": {
      "description": "Function defining how each item should be rendered in the item list.\nThe signature of the function passed to itemToElement must be either:\n  (item) => <Element />\n    or\n  (item, inputValue) => <Element />\nThe optional inputValue parameter may be useful when the component is uncontrolled;\nit can be passed to the HighlightedText component for substring-match highlighting.\nNote that while itemToElement is essentially a more powerful itemToString, a sensible itemToString\nis still typically required in addition to itemToElement because itemToString is needed to:\npopulate the input upon selecting an item when the component is uncontrolled, to determine\nwhether the user can create an item when the component is in creatable mode, etc.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "itemToKey": {
      "description": "Function for computing a unique key for each item, to make React happy. If unspecified,\nitemToString will be used instead, which is preferable, but sometimes insufficient. For\nexample, the case where you have multiple items for which you want identical filtering\nbehavior for, but don\u2019t necessarily render the same way (w/ itemToElement).",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "label": {
      "description": "An optional label that will appear above the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placeholder": {
      "description": "Used to display placeholder text inside the input.",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "maxHeight": {
      "description": "A number that sets the max height of the dropdown in pixels\n(e.g. 100)\nIf not all items fit within the set height,\nthe user will need to scroll to see the other options.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "maxItems": {
      "description": "The largest number of items to be rendered in a list. After\nthis number has been reached, further items will not be\ndisplayed. There is no indicator that there are further items.\nThe creatable item is not included in this count.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "onIconClick": {
      "description": "Takes (event, inputString). Fired when the user clicks on\nthe component's icon.",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "onClear": {
      "description": "If provided, a \"clear\" icon will be displayed once an item\nis selected. When the clear icon is clicked, the function passed to\nonClear will be called. It's argument will be Downshift's clearSelection\nfunction which allows the consumer to clear the current inputValue\nand selectedValue.\nExample:\n <Select\n   onClear={(clearSelection) => {\n     // This can be anything you want\n     doSomething();\n\n     // Call this to clear the input/selection\n     clearSelection();\n   }}\n />",
      "type": {
        "name": "func"
      },
      "required": false
    },
    "maxLength": {
      "description": "If using a typeahead, the max number of characters a user can type. Useful for creatable.",
      "type": {
        "name": "number"
      },
      "required": false
    },
    "selectedItem": {
      "description": "The currently selected item.\nSet this if you want to use Select as controlled component.",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }, {
          "name": "number"
        }]
      },
      "required": false
    },
    "selectedItems": {
      "description": "An array of the currently selected items.\nOnly use when multiSelect is true.\nSet this if you want to use Select as controlled component.",
      "type": {
        "name": "array"
      },
      "required": false
    },
    "itemListMaxWidth": {
      "description": "Allows specifying a max-width for the item list.\nAccepts standard max-width values (e.g. \"100%\" or \"100px\").",
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "number"
        }]
      },
      "required": false
    }
  }
};